import { render, staticRenderFns } from "./medicalreportloginView.vue?vue&type=template&id=26ccbf80"
import script from "./medicalreportloginView.vue?vue&type=script&lang=js"
export * from "./medicalreportloginView.vue?vue&type=script&lang=js"
import style0 from "./medicalreportloginView.vue?vue&type=style&index=0&id=26ccbf80&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports